document.addEventListener("DOMContentLoaded", () => {
  if (window.bsLocation === "") {
    const cityMenuBlock = document.getElementById(
      "block-views-block-city-menu-block-1"
    );

    if (cityMenuBlock) {
      const viewHeader = cityMenuBlock.querySelector(
        ".view-content .view-header"
      );

      if (viewHeader) {
        viewHeader.prepend(viewHeader.querySelector(".view-header"));
        viewHeader.classList.add("active");
        viewHeader.innerHTML =
          "<div class='field-content'><a>Please choose your City</a></div>";
      }
    }
  }

  const viewHeaderElement = document.querySelector(
    "#fullscreen-menu #block-views-block-city-menu-block-1 .view-content .view-header"
  );

  if (viewHeaderElement) {
    viewHeaderElement.addEventListener("click", function (e) {
      viewHeaderElement.parentElement.classList.toggle("opened");
    });
  }
});